import {createContext} from 'react';

export type ValueContextType = {
  value: string;
  setValue: (value: string) => void;
}

export const TitleContext = createContext<ValueContextType | any>("");